import React, { useState } from "react";
import { categories, ratingDetails } from "../constants/settings";
import { wheel } from "../constants/settings";
import PrivacyPolicy from "../components/PrivacyPolicy";
import { Table, Typography, Form, Input, Button, Checkbox } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";

const calculateIndex = (score) => {
  if (score > 4) {
    return "Thriving";
  } else if (score <= 4 && score > 1) {
    return "Progressing";
  } else if (score <= 1 && score > -3) {
    return "Stagnant";
  } else {
    return "Struggling";
  }
};

function updateUserInMailchimp(payload, endpoint) {
  const url = `https://elated-heyrovsky-f6035a.netlify.app/.netlify/functions/${endpoint}`;
  const fieldForEndpoint =
    payload.field === "surroundings" ? "SURROUND" : payload.field.toUpperCase();
  const body = JSON.stringify({
    user: payload.user,
    field: fieldForEndpoint,
    score: payload.score
  });

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "*/*"
  };

  return fetch(url, {
    headers: headers,
    method: "post",
    body: body,
    mode: "cors"
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("error in posting email", error));
}

function updateUserInMailchimpBulk(payload, endpoint) {
  const url = `https://elated-heyrovsky-f6035a.netlify.app/.netlify/functions/${endpoint}`;

  const { results } = payload;
  const finalResult = Object.entries(results).reduce(
    (accum, [currentKey, currentVal]) => {
      const upperKey =
        currentKey === "surroundings" ? "SURROUND" : currentKey.toUpperCase();
      const currentScore = Object.values(currentVal);
      if (currentScore.length > 0) {
        const score = currentScore.reduce((a, v) => {
          return a + v;
        }, 0);
        accum[upperKey] = calculateIndex(score);
      }
      return accum;
    },
    {}
  );

  const body = JSON.stringify({
    user: payload.user,
    results: finalResult
  });

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "*/*"
  };

  return fetch(url, {
    headers: headers,
    method: "post",
    body: body,
    mode: "cors"
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => console.log("error in posting email", error));
}

function postToMailChimp(newVals) {
  const url =
    "https://elated-heyrovsky-f6035a.netlify.app/.netlify/functions/handlesignup";
  const body = JSON.stringify({
    firstName: newVals.firstName,
    lastName: newVals.lastName,
    email: newVals.email,
    score: "0"
  });

  const headers = {
    "Content-Type": "application/x-www-form-urlencoded",
    Accept: "*/*"
  };

  return fetch(url, {
    headers: headers,
    method: "post",
    body: body,
    mode: "cors"
  })
    .then((response) => {
      return response.json();
    })
    .then((json) => {
      return json.id;
    })
    .catch((error) => console.log("error in posting email", error));
}

function SignUp({ onSubmit, isLoading }) {
  const [showModal, setShowModal] = useState(false);
  const [submitAllowed, setSubmitAllowed] = useState(false);
  const [form] = Form.useForm();

  const itemLayout = {
    labelCol: { span: 4 },
    layout: "horizontal",
    size: "large"
  };

  return (
    <div
      style={{
        alignItems: "center",
        paddingLeft: "5px",
        paddingTop: "5px"
      }}
    >
      <Form
        form={form}
        onValuesChange={() => {}}
        onFinish={() => onSubmit(form)}
        onFinishFailed={() => {}}
        {...itemLayout}
      >
        <Form.Item
          label="First Name"
          name="firstname"
          rules={[{ required: true, message: "Please enter your first name" }]}
        >
          <Input placeholder="Hello!" />
        </Form.Item>
        <Form.Item
          label="Last Name"
          name="lastname"
          rules={[{ required: true, message: "Please enter your last name" }]}
        >
          <Input placeholder="Happy to have you!" />
        </Form.Item>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please enter your email"
            }
          ]}
        >
          <Input placeholder="myemail@address.com" />
        </Form.Item>
        <Form.Item>
          <Button
            style={{
              backgroundColor: "Black",
              borderColor: "Black",
              color: "White"
            }}
            disabled={!submitAllowed}
            loading={isLoading}
            type="primary"
            htmlType="submit"
          >
            Sign up!
          </Button>
        </Form.Item>
        <Form.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "center"
            }}
          >
            <Checkbox
              onChange={(event) => setSubmitAllowed(event.target.checked)}
            ></Checkbox>
            <div
              style={{
                paddingLeft: "5px",
                textAlign: "left",
                maxWidth: "500px"
              }}
            >
              By entering your email, you agree for Soulabode to contact you via
              email with your Soul Care Wheel results, product information, and
              other wellness related content. For more information, please view
              our
              <Typography.Link onClick={() => setShowModal(true)}>
                {" "}
                privacy policy
              </Typography.Link>
              .
            </div>
          </div>
        </Form.Item>
      </Form>
      <PrivacyPolicy
        shouldShow={showModal}
        onCancel={() => setShowModal(false)}
        onOk={() => setShowModal(false)}
      />
    </div>
  );
}

function ResultsScore({
  surveyResults,
  currentCategory,
  shouldShowSignup,
  setUserInfo
}) {
  const [isLoading, setIsLoading] = useState(false);
  const currentResult = Object.values(
    surveyResults[currentCategory.key]
  ).reduce((a, v) => {
    return a + v;
  }, 0);
  const scoreResult = calculateIndex(currentResult);

  return (
    <>
      <div
        style={{
          position: "relative"
        }}
      >
        <span>
          <Typography.Title level={4}>
            {/* TODO: Pick a specific color */}
            You are currently{" "}
            <span style={{ fontSize: "25px" }}>
              {scoreResult.toUpperCase()}
            </span>
          </Typography.Title>
        </span>
        <Typography.Paragraph style={{ fontSize: "15px" }}>
          <span>{ratingDetails[scoreResult].description} </span>
          {shouldShowSignup ? (
            <>
              {/* <Divider /> */}
              <div style={{ marginTop: "15px" }}>{""}</div>
              <div>
                <span>
                  <b>{""}Congratulations!</b> You've completed the{" "}
                  {currentCategory.title} dimension of the Soul Care Wheel. Get
                  your full assessment results by signing up below.
                </span>
              </div>
            </>
          ) : null}
          {shouldShowSignup ? (
            <SignUp
              key="signup"
              isLoading={isLoading}
              style={{ position: "relative" }}
              onSubmit={(formInfo) => {
                const info = {
                  firstName: formInfo.getFieldValue("firstname"),
                  lastName: formInfo.getFieldValue("lastname"),
                  email: formInfo.getFieldValue("email")
                };
                setIsLoading(true);
                postToMailChimp(info).then((id) => {
                  setIsLoading(false);
                  setUserInfo((old) => {
                    const newVals = {
                      firstName: formInfo.getFieldValue("firstname"),
                      lastName: formInfo.getFieldValue("lastname"),
                      email: formInfo.getFieldValue("email"),
                      isSignedUp: true,
                      id: id
                    };
                    return { ...old, ...newVals };
                  });
                });
              }}
            />
          ) : (
            <div style={{ paddingTop: "5px" }}>
              <b style={{ fontSize: "15px" }}>
                Click the Bar Above to Continue
              </b>
            </div>
          )}
        </Typography.Paragraph>
      </div>
    </>
  );
}

function ResultsTable({ surveyResults }) {
  // Set up columns
  const columns = [];

  columns.push({
    title: "Well-being State",
    dataIndex: "state",
    key: "state",
    fixed: "left",
    align: "center",
    render: (t) => (
      <div>
        <b>{t}</b>
      </div>
    )
  });
  const categoryCols = categories.map((c) => {
    return {
      title: (
        <div
          style={{
            color: wheel[c].color,
            fontSize: "15px",
            textAlign: "center"
          }}
        >
          {wheel[c].title}
        </div>
      ),
      dataIndex: c,
      key: c,
      render: (text) => {
        return <div style={{ textAlign: "center" }}>{text}</div>;
      }
    };
  });
  const allColumns = [...columns, ...categoryCols];

  const emptyRows = Object.keys(ratingDetails).map((rating, index) => {
    return { key: index, state: rating };
  });

  // Make a blank row for each category
  /**
   * {key: 0, state, Thriving, soul: "", connection: "", mindset: "", feelings: "", movement: "", surroundings: ""}
   *
   */
  const dummyRows = emptyRows.map((outcome) => {
    const emptyRow = categories.reduce((accum, c) => {
      accum[c] = "";
      return accum;
    }, {});
    return { ...outcome, ...emptyRow };
  });

  // Search through each category, find the result for that category, then
  // find it's corresponding state and match the data
  categories.forEach((c, index) => {
    const currentResult = Object.values(surveyResults[c]);

    if (currentResult.length > 1) {
      const result = calculateIndex(
        currentResult.reduce((accum, result) => accum + result),
        0
      );
      dummyRows.forEach((row) => {
        if (row.state === result) {
          row[c] = <CheckCircleOutlined />;
        }
      });
    }
  });

  return (
    <Table
      columns={allColumns}
      dataSource={dummyRows}
      sticky
      pagination={false}
      scroll={{ x: 950 }}
      bordered
      style={{ overflowWrap: "normal" }}
    />
  );
}

export {
  ResultsScore,
  ResultsTable,
  updateUserInMailchimp,
  updateUserInMailchimpBulk,
  calculateIndex
};
